import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@constants/routes';
import { useConfigurationStore } from '@store/use-configuration-store';
import { useUserStore } from '@store/use-user-store';

function getRedirectRoute(module: string): string {
  switch (module) {
    case 'elearning-wp-remote':
      return ROUTES.EWR_LOGOUT;
    case 'elearning-external':
      return ROUTES.EEL_LOGOUT;
    case 'elearning-wp-onsite':
      return ROUTES.EWOS_LOGIN;
    default:
      return ROUTES.VR_LOGIN;
  }
}

function LogoutPage() {
  const navigate = useNavigate();
  const { logout } = useUserStore();
  const { module } = useConfigurationStore();

  useEffect(() => {
    const redirectTo = getRedirectRoute(module);
    logout();
    navigate(redirectTo, { replace: true });
  }, []);

  return null;
}

export default LogoutPage;
